import * as React from "react";
import { Routes, Route, Outlet, useNavigate, Navigate } from "react-router-dom";
import './App.css';
import { ROUTES } from "./utils/constants.js";
import ProtectedRoute from './auth/protected-route.js'
import { useSelector } from "react-redux";
import { SetupInterceptors } from 'utils/http-client';
import { store } from "./store";
import AppLoader from "./components/app-loader/AppLoader.js";
import AppDashboard from "./components/app-dashboard/AppDashboard.js";
import ProjectDashboard from "./components/project-dashboard/ProjectDashboard.js";
import AppProject from "./components/app-project/AppProject.js";
import AppConsole from "./components/app-console/AppConsole.js";
import { AppInvalid } from "components/app-invalid";

const ForgotPasswordPage = React.lazy(() => import("./pages/forgot-password/ForgotPassword"));
const ResetPasswordPage = React.lazy(() => import("./pages/reset-password/ResetPassword"));
const ResetPasswordSuccessPage = React.lazy(() => import("./pages/reset-password/ResetPasswordSuccess"));
const LoginPage = React.lazy(() => import("./pages/login/Login.js"));
const SignupPage = React.lazy(() => import("./pages/signup/Signup.js"));
const RequisitionsPgae = React.lazy(() => import("./pages/requisition/Requisition"));
const ProjectsPage = React.lazy(() => import('./pages/project/Project.js'));
const ActivitiesPage = React.lazy(() => import("./pages/activities/Activities"));
const LimitsPage = React.lazy(() => import('./pages/limits/Limits.js'));
const AccountSettingsPage = React.lazy(() => import('./pages/account-settings/AccountSettings.js'));
const ServersPage = React.lazy(() => import("./pages/servers/Server"));
const ServerCreatePage = React.lazy(() => import("./pages/server-create-form/ServerCreateForm.js"));
const ServerDetailPage = React.lazy(() => import("./pages/server-detail/ServerDetail.js"));
const ServerConsolePage = React.lazy(() => import("./pages/server-detail/server-console/ServerConsole"));
const VolumesPage = React.lazy(() => import("./pages/volumes/Volumes"));
const ImagesPage = React.lazy(() => import("./pages/images/Images"));
const FloatingIpPage = React.lazy(() => import("./pages/floating-ip/FloatingIP"));
const NetworksPage = React.lazy(() => import("./pages/networks/Networks"));
const UsersPage = React.lazy(() => import("./pages/users/Users"));
const EventsPage = React.lazy(() => import("./pages/events/Events"));
const DeletePage = React.lazy(() => import("./pages/project-delete/ProjectDelete"));
const AccountPayementGatewayPage = React.lazy(() => import("./pages/payment-gateway/PaymentGateway"));
const PaymentSuccessPage = React.lazy(() => import("./pages/payment-success/PaymentSuccess"));

const LazyLoad = ({ Comp }) => {
  return (
    <React.Suspense fallback={<AppLoader isLoading={true} />}>
      <Comp />
    </React.Suspense>
  );
};


export default function App() {
  const navigate = useNavigate();
  const { userToken } = useSelector((state) => state.user);
  // const { data } = useSelector((state) => state.projects);
  SetupInterceptors(store, navigate);

  return (
    <div>
      <Routes>
        <Route path={ROUTES.LOGIN} element={
          userToken ? <Navigate to="/project" />
            : <React.Suspense fallback={<>...</>}>
              <LoginPage />
            </React.Suspense>
        } />
        <Route
          path={ROUTES.FORGOTPASSWORD}
          element={<LazyLoad Comp={ForgotPasswordPage} />}
        />
        <Route
          path={ROUTES.RESETPASSWORD}
          element={<LazyLoad Comp={ResetPasswordPage} />}
        />
        <Route
          path={ROUTES.RESETPASSWORD_SUCCESS}
          element={<LazyLoad Comp={ResetPasswordSuccessPage} />}
        />
        <Route path={ROUTES.SIGNUP}
          element={
            userToken ? <Navigate to="/project" />
              : <React.Suspense fallback={<>...</>}>
                <SignupPage />
              </React.Suspense>
          } />
        <Route path={ROUTES.DEFAULT} element={<Outlet />}>
        <Route path={ROUTES.DEFAULT} element={
          userToken ? <Navigate to="/project" />
            : <React.Suspense fallback={<>...</>}>
              <LoginPage />
            </React.Suspense>
        } />
        <Route
          path={ROUTES.PROJECT}
          element={
            <ProtectedRoute>
              <LazyLoad Comp={ProjectsPage} />
            </ProtectedRoute>
          }
        />

        <Route
          path={ROUTES.ACTIVITIES}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={ActivitiesPage} />
              </ProtectedRoute>
            }
          />

        </Route>
        <Route
          path={ROUTES.LIMITS}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={LimitsPage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.ACCOUNT_SETTINGS}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={AccountSettingsPage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.ACCOUNT_PAYMENT}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={AccountSettingsPage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.ACCOUNT_USAGE}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={AccountSettingsPage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.ACCOUNT_SSHKEY}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={AccountSettingsPage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.ACCOUNT_USAGE_HOURLY}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={AccountSettingsPage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.ACCOUNT_PAYMENT_GATEWAY}
          element={<LazyLoad Comp={AppDashboard} />}
        >
          <Route
            path=""
            element={
              <ProtectedRoute>
                <LazyLoad Comp={AccountPayementGatewayPage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.PROJECT}
          element={
            <ProtectedRoute>
              <LazyLoad Comp={AppProject} />
            </ProtectedRoute>
          }
        >
          <Route
            path=":id"
            element={
              <ProtectedRoute>
                <LazyLoad Comp={ProjectDashboard} />
              </ProtectedRoute>
            }
          >
            <Route
              path={ROUTES.REQUISITION}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={RequisitionsPgae} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVERS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServersPage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_CREATE}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerCreatePage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_ACCESS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_NETWORK}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_VOLUMES}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_BACKUPS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_FIREWALL}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_STATISTICS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_EVENTS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_RESIZE}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_DESTROY}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ServerDetailPage} />
                </ProtectedRoute>
              }
            />

            <Route
              path={ROUTES.VOLUMES}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={VolumesPage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.IMAGES}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={ImagesPage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.FLOATING_IP}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={FloatingIpPage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.NETWORKS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={NetworksPage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.USERS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={UsersPage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.EVENTS}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={EventsPage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.DELETE}
              element={
                <ProtectedRoute>
                  <LazyLoad Comp={DeletePage} key={Date.now()} />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>
        <Route
          path={ROUTES.DEFAULT}
          element={
            <ProtectedRoute>
              <LazyLoad Comp={AppConsole} />
            </ProtectedRoute>
          }
        >
          <Route
            path={ROUTES.SERVER_DETAIL + ROUTES.SERVER_CONSOLE}
            element={
              <ProtectedRoute>
                <LazyLoad Comp={ServerConsolePage} />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={ROUTES.PAYMENT_SUCCESS}
          element={
            <ProtectedRoute>
              <LazyLoad Comp={PaymentSuccessPage} />
            </ProtectedRoute>
          }
        />

          <Route path="*" element={<LazyLoad Comp={AppInvalid} />} />
        </Route>
      </Routes>
    </div>
  );
}
